module.exports = __webpack_public_path__ + "static/media/sbom-slide-4.e89105bc.jpg";